import React, { Component } from "react";
import PanelWrapper from "./layout/PanelWrapper";
import styled from "styled-components";

class Error extends Component {
  render() {
    return (
      <PanelWrapper padding="100px">
        <Message>An error occured...</Message>
        <Description>Please refresh the page to try again.</Description>
      </PanelWrapper>
    );
  }
}

const Message = styled.h1`
  padding: 10px 10px 0 10px;
  margin: 0;
  color: #ff0000;
  text-transform: uppercase;
  font-size: 20px;
  text-align: center;
`;

const Description = styled.p`
  color: #ffffff;
  padding: 10px 10px 0 10px;
  margin: 0;
  font-size: 16px;
  text-align: center;
`;

export default Error;



// WEBPACK FOOTER //
// ./src/components/Error.js